import { Cog8ToothIcon } from "@heroicons/react/24/outline";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { useStore } from "@nanostores/react";
import { ReactElement } from "react";

import { exportGraphAsJson } from "../../services/graph/export-graph-as-json.ts";
import { exportGraphAsPng } from "../../services/graph/export-graph-as-png.ts";
import { $userAppSettings } from "../../stores/user-app-settings.ts";
import { Button } from "../catalyst/Button.tsx";
import { Checkbox } from "../catalyst/Checkbox.tsx";
import { CheckboxField } from "../catalyst/CheckboxField.tsx";
import { Label } from "../catalyst/Label.tsx";
import { Tooltip } from "../Tooltip.tsx";
import { FloatingTool } from "./FloatingTool.tsx";

export const FloatingSettings = (): ReactElement => {
  const userAppSettings = useStore($userAppSettings);

  const handleShowEdgeLabelsChange = (checked: boolean): void => {
    $userAppSettings.setKey("showEdgesLabels", checked);
  };

  const handleAutoLayoutAfterWorkflowChange = (checked: boolean): void => {
    $userAppSettings.setKey("autoLayoutAfterWorkflow", checked);
  };

  const settingsIcon = (
    <Cog8ToothIcon className="h-6 w-6 cursor-pointer text-zinc-400 hover:text-zinc-200" />
  );

  const settingsContent = (
    <div className="ring-.75 min-w-[200px] rounded-lg bg-zinc-900/90 p-3 shadow-lg ring-zinc-600">
      <div className="flex flex-col space-y-3">
        {/* Graph Settings Section */}
        <div>
          <div className="space-y-2">
            <CheckboxField>
              <Checkbox
                checked={userAppSettings.showEdgesLabels}
                color="dark"
                onChange={handleShowEdgeLabelsChange}
              />
              <Label>Show Edge Labels</Label>
            </CheckboxField>
            <CheckboxField>
              <Checkbox
                checked={userAppSettings.autoLayoutAfterWorkflow}
                color="dark"
                onChange={handleAutoLayoutAfterWorkflowChange}
              />
              <div className="flex items-center gap-1">
                <Label>Auto-layout</Label>
                <Tooltip content="Automatically apply hierarchical layout after workflow completion when new nodes or edges are added">
                  <InformationCircleIcon className="h-4 w-4 text-zinc-400 hover:text-zinc-300" />
                </Tooltip>
              </div>
            </CheckboxField>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-zinc-600" />

        {/* Export Section */}
        <div>
          <div className="space-y-1">
            <Button
              className="w-full !justify-start font-normal"
              onClick={exportGraphAsPng}
              plain
              size="sm"
            >
              Save as PNG
            </Button>
            <Button
              className="w-full !justify-start font-normal"
              onClick={exportGraphAsJson}
              plain
              size="sm"
            >
              Export as JSON
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  return <FloatingTool icon={settingsIcon}>{settingsContent}</FloatingTool>;
};
